import { useNavigate } from 'react-router-dom';

// Variable pour stocker la fonction `navigate` globalement.
let navigateFunction: (to: string) => void;

/**
 * Fonction pour définir la fonction `navigate` globale.
 * @param navigate La fonction `navigate` à stocker.
 */
export const setNavigateFunction = (navigate: (to: string) => void) => {
  navigateFunction = navigate;
};

/**
 * Fonction pour obtenir la fonction `navigate` globale.
 * @returns La fonction `navigate` stockée.
 */
export const getNavigateFunction = () => {
  return navigateFunction;
};

/**
 * Hook custom pour initialiser et stocker la fonction `navigate` globalement.
 * Doit être appelé dans un composant React utilisant `useNavigate`.
 */
export const useAppNavigate = () => {
  const navigate = useNavigate();
  setNavigateFunction(navigate);
};